import React from 'react';
import './homework.css'; // Import CSS styles

const ComingSoon = () => {
  return (
    <div className="coming-soon-container">
      <h1 className="title">Coming Soon</h1>
      <p className="message">We are working hard to bring this feature to you. Stay tuned!</p>
      <div className="countdown">
        <span>00</span>:<span>00</span>:<span>00</span>:<span>00</span>
      </div>
    </div>
  );
};

export default ComingSoon;